.bannerContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--sentiment-background-info);
  border-radius: 12px;
  padding: 16px;
}

.bannerContainer.info {
  background-color: var(--sentiment-background-info);
}
.bannerContainer.notice {
  background-color: var(--sentiment-background-notice);
}
.bannerContainer.positive {
  background-color: var(--sentiment-background-positive);
}

.leftContent {
  display: flex;
  align-items: center;
}

.icon {
  margin-right: 12px;
  flex-shrink: 0;
}

.message {
  color: var(--static-text-standard);
  font-size: var(--fs-normal);
  line-height: 1.5;
  padding-left: 10px;
}

.dismissButton {
  margin-left: 16px;
  color: var(--static-text-strong);
  font-weight: 500;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
}

.dismissButton:hover {
  text-decoration: underline;
}
